import { HeaderTooltip } from "../core/components/header-tooltip.js";
import { useUserQuery } from "../core/hooks/use-user-query.js";
import { i18n } from "../../utils/i18n.js";
import { useKeycloak } from "../core/context/keycloak.js";
import { MenuLink } from "../core/components/menu-link.js";
import { Avatar, Popover, Skeleton } from "@tecsinapse/cortex-react";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { Trans } from "@lingui/react";
//#region src/modules/account-settings/index.tsx
var AccountSettings = ({ showMyAccount, customOptionsUser, version, linkPortal }) => {
	const { data, isLoading } = useUserQuery();
	const { logout } = useKeycloak();
	return /* @__PURE__ */ jsxs(Popover.Root, {
		trigger: "click",
		children: [/* @__PURE__ */ jsx(Popover.Trigger, { children: /* @__PURE__ */ jsx(HeaderTooltip, {
			text: i18n._(
				/** i18n */
				{ id: "REJN7D" }
			),
			children: isLoading ? /* @__PURE__ */ jsx(Skeleton, { className: "rounded-full w-8 h-8" }) : /* @__PURE__ */ jsx(Avatar, {
				name: String(data?.nome),
				src: data?.avatarLink ?? void 0,
				className: "mb-micro"
			})
		}) }), /* @__PURE__ */ jsx(Popover.Content, { children: /* @__PURE__ */ jsxs("div", {
			className: "flex bg-white flex-col",
			children: [
				/* @__PURE__ */ jsxs("div", {
					className: "px-deca py-mili flex flex-row items-center gap-x-mili border-b border",
					children: [/* @__PURE__ */ jsx(Avatar, {
						name: String(data?.nome),
						src: data?.avatarLink ?? void 0
					}), /* @__PURE__ */ jsxs("div", {
						className: "flex flex-col gap-x-mili",
						children: [/* @__PURE__ */ jsx("p", {
							className: "text-sub",
							children: data?.nome
						}), version && /* @__PURE__ */ jsx("p", {
							className: "text-label text-medium",
							children: version
						})]
					})]
				}),
				showMyAccount ? /* @__PURE__ */ jsx("div", {
					className: "flex items-center gap-x-mili hover:bg-secondary-light hover:cursor-pointer px-deca py-mili",
					children: /* @__PURE__ */ jsx(MenuLink, {
						to: "/minha-conta",
						className: "no-underline text-sub text-black",
						linkPortal,
						children: /* @__PURE__ */ jsx(Trans, { id: "nwikRk" })
					})
				}) : null,
				(customOptionsUser ?? []).length > 0 ? (customOptionsUser ?? []).map((option) => /* @__PURE__ */ jsx("div", {
					className: "flex items-center hover:bg-secondary-light hover:cursor-pointer px-deca py-mili text-sub text-black",
					children: /* @__PURE__ */ jsx(MenuLink, {
						className: "no-underline text-sub text-black",
						to: option.path,
						linkPortal,
						children: /* @__PURE__ */ jsx("p", { children: option.label })
					})
				}, option.path)) : null,
				/* @__PURE__ */ jsx("button", {
					onKeyDown: async () => await logout?.(),
					onClick: async () => await logout?.(),
					className: "flex items-center bg-white hover:bg-secondary-light px-deca py-mili text-sub text-black",
					children: /* @__PURE__ */ jsx(Trans, { id: "8cDgMo" })
				})
			]
		}) })]
	});
};
//#endregion
export { AccountSettings };
